<template>
    <div>
        <table class="vs-table vs-table--tbody-table striped-table" :style="{overflow:'auto',height:'60vh'}" id="loading-table-1-compliance">
        <thead>
        <tr class="tr-values vs-table--tr tr-table-state-null">
            <th :style="{width:'15%'}" class="qb-sticky"><b>{{$t('client')}}</b></th>
            <th :style="{width:'10rem'}" class="qb-sticky"><b>{{$tc('facility')}}</b></th>
            <th :style="{width:'30%'}" class="qb-sticky"><b>{{$t('title')}}/{{$t('category')}}</b></th>
            <th :style="{width:'17%'}" class="qb-sticky"><b>{{$t('status')}} {{$t('and')}} {{$t('expiration')}}</b></th>
            <th :style="{width:'23%'}" class="qb-sticky"><b>{{$t('comments')}}</b></th>
            <th :style="{width:'10%'}" class="qb-sticky"><b></b></th>
        </tr>
        </thead>

        <tbody :style="{overflow:'auto'}">
        <template v-for="(compliance, index) in users">
            <tr class="tr-body tr-values vs-table--tr tr-table-state-null" :key="index">
                <td class="text-left"  :title="compliance.client_name">
                    {{compliance.client_short_name}}
                </td>
                <td class="text-left comment-truncate">
                    {{compliance.facility}}
                </td>
                <td class="text-left comment-truncate" >
                    {{compliance.title}}
                        <br>
                        <span class="material-icons sm" :style="{fontSize:'8px',color:compliance.category_color}">
                                lens
                        </span>
                        <span class="text-left comment-truncate">
                        {{  compliance.category_name}}
                        </span>
                </td>
                <td class="text-center" style="display:flex;">
                    <vs-chip class="label-status" :color="compliance.status_color">{{compliance.status_name}}<br>{{compliance.expiration_date}}</vs-chip>
                </td>
                <td class="text-left comment-truncate">
                    {{  compliance.comment}}
                </td>
                <td class="text-left ">
                    <action-icon icon="ArrowRightCircleIcon" :tooltip="$t('go')" @click="redirectCompliance(compliance)" />
                </td>
            </tr>
        </template>
        </tbody>
    </table>
    </div>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon.vue'
export default {
  props:['users'],
  components:{
    ActionIcon
  },
  methods:{
    redirectCompliance(compliance){
      this.$store.dispatch('setFilter',{ item:compliance });
      this.$router.push({ path:'/compliance' })
    }
  }
}
</script>

<style>
 th, td {
    font-size: 0.9rem;
  }
  .smallFont{
      font-size: 8px;
  }
  .bg-color{
      background-color:#86E6FA
  }
  .sm{
      font-size: 10px;
  }

  .blue-info{
      color:#14AFDC
  }

  .label-status { max-width: 9rem; min-width: 2rem;  color: white; text-align: center; border-radius: .3em; }

  .content-center{ text-align: center; }
  .vx-card__body{
      padding: 10px 0px !important;
  }

  .striped-table table{
      table-layout: fixed;
      overflow: auto;
  }

  .striped-table.vs-con-table .vs-con-tbody {
    height: 40vh !important;
    overflow: auto;
}

.comment-truncate{
    overflow-wrap: break-word;
}

</style>